.menuButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  outline-offset: -8px;
  position: absolute;
  right: 0;
  height: 100%;
  padding: 0;

  @media (max-width: 800px) {
    padding: 0 calc(0.5 * var(--inner-padding));
    overflow: hidden;
  }

  &:focus-visible {
    outline-offset: -4px;
  }

  .menuIcon {
    height: 32px;
    fill: none;
    stroke: currentColor;
    stroke-width: 2px;

    @media (max-width: 800px) {
      transform: scaleX(2) scaleY(0.5);
      fill: currentColor;
    }
  }
}
